const TipoDocumentoEnum = {

    RXH: {
        tid_id: 6,
        tid_descripcion: "Recibos x honorarios"
    },

}

export default TipoDocumentoEnum